<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import DadosFaturamento from './compartilhado/FormDadosFaturamento.vue';
  import DadosCobranca from './compartilhado/FormDadosCobranca.vue';
  import DadosFatura from './compartilhado/FormDadosFatura.vue';
  import AdicionarServicos from './compartilhado/FormAdicionarServicos.vue';
  import ListaServicos from './compartilhado/FormListaServicos.vue';
  import solicitacaoFaturamentoMultiservicoServico from '../servico';
  import radio from '~componentes/Radio.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  
  export default {
    components: { DadosFaturamento, DadosCobranca, DadosFatura, AdicionarServicos, ListaServicos, radio, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        tipoDocumento: 'CNPJ',
        arquivos: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Faturamento Multiserviços - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-faturamento-multiservicos.nova';
    },
    methods: {
      buscarBeneficiario() {
        $('#avancar').button('loading');
        
        return pessoaServico
          .busca(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');
            
            this.solicitacao.documento = pessoa.cpfCnpj; 
            this.solicitacao.nome = pessoa.nomePessoaFisicaJuridica;
            this.solicitacao.enderecoFaturamento = pessoa.endereco;
            this.solicitacao.numeroFaturamento = pessoa.numero;
            this.solicitacao.complementoFaturamento = pessoa.complemento;
            this.solicitacao.bairroFaturamento = pessoa.bairro;
            this.solicitacao.cidadeFaturamento = pessoa.cidade;
            this.solicitacao.ufFaturamento = pessoa.estado;
            this.solicitacao.cepFaturamento = pessoa.cep;
            this.solicitacao.telefoneFaturamento = pessoa.telefone1;
            this.solicitacao.faxFaturamento = pessoa.fax;
            this.solicitacao.contatoFaturamento = pessoa.email;
            this.solicitacao.inscricaoEstadual = pessoa.identidadeInscEstadual;
            this.solicitacao.inscricaoMunicipal = pessoa.identidadeInscMunicipal;
            
            if (pessoa.enderecoCobranca) {
              this.solicitacao.enderecoCobranca = pessoa.enderecoCobranca;
              this.solicitacao.numeroCobranca = pessoa.numeroCobranca;
              this.solicitacao.complementoCobranca = pessoa.complementoCobranca;
              this.solicitacao.bairroCobranca = pessoa.bairroCobranca;
              this.solicitacao.cidadeCobranca = pessoa.cidadeCobranca;
              this.solicitacao.ufCobranca = pessoa.estadoCobranca;
              this.solicitacao.cepCobranca = pessoa.cepCobranca;
            } else {
              this.solicitacao.enderecoCobranca = pessoa.endereco;
              this.solicitacao.numeroCobranca = pessoa.numero;
              this.solicitacao.complementoCobranca = pessoa.complemento;
              this.solicitacao.bairroCobranca = pessoa.bairro;
              this.solicitacao.cidadeCobranca = pessoa.cidade;
              this.solicitacao.ufCobranca = pessoa.estado;
              this.solicitacao.cepCobranca = pessoa.cep;
            }
            
            this.dadosBancarios = pessoa.dadosBancarios;
            
            this.$set(this, 'mostrarFormulario', true);
          })
          .catch(error => {
            $('#avancar').button('reset');

            this.solicitacao.documento = this.documento;
			
			      this.$set(this, 'mostrarFormulario', true);
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosFaturamento
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-faturamento"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosCobranca.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cobranca"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosFatura.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-fatura"]').tab('show');
            }

            return valido;
          })
          .then(this.validarSePossuiItens)
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-faturamento-multiservicos.relatorio', id, 'solicitacao-faturamento-multiservicos');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      validarSePossuiItens(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.solicitacao.itens.length > 0) return true;

        $('#tabs a[href="#tab-adicionar-servicos"]').tab('show');
        
        this.$swal(
          '',
          'A solicitação deve possuir ao menos um serviço.',
          'info'
        );

        throw new Error("validacao");
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        const arquivos = this.$refs.adicionarArquivos.arquivos;
        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        
        if (this.$route.params.id) {
          return solicitacaoFaturamentoMultiservicoServico.alterar(copiaSolicitacao, arquivos, this.$route.params.id);
        } else {
          return solicitacaoFaturamentoMultiservicoServico.adicionar(copiaSolicitacao, arquivos);
        }
      },
      camposSolicitacao() {
        return {
          idCoordenador: '',
          idProjeto: '',
          dataSolicitacao: '',
          observacao: '',
          complemento: '',
          nome: '',
          documento: '',
          inscricaoEstadual: '',
          enderecoFaturamento: '',
          numeroFaturamento: '',
          complementoFaturamento: '',
          cidadeFaturamento: '',
          ufFaturamento: '',
          bairroFaturamento: '',
          cepFaturamento: '',
          telefoneFaturamento: '',
          faxFaturamento: '',
          contatoFaturamento: '',
          obsFaturamento: '',
          enderecoCobranca: '',
          numeroCobranca: '',
          complementoCobranca: '',
          cidadeCobranca: '',
          ufCobranca: '',
          bairroCobranca: '',
          cepCobranca: '',
          formaPagamento: '0',
          destinoNotaFiscal: '',
          idRubrica: '',
          idSubRubrica: '',
          idConta: '',
          agencia: '',
          banco: '',
          contaCorrente: '',
          tipoConta: '',
          idUnidade: '',
          idDepartamento: '',
          inscricaoMunicipal: '',
          dataPagamento: '',
          tipoPagamento: 1,
          idCodItemServico: '',
          itens: [],
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
          }
        };
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoFaturamentoMultiservicoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => {
            solicitacao.dataPagamento = this.$options.filters.formatarNumeroEmData(solicitacao.dataPagamento);
            solicitacao.formaPagamento = solicitacao.formaPagamento.toString(); 
          })
          .then(() => {
            return this.$refs.dadosFatura.listaUnidades();
          })
          .then(() => {
            this.solicitacao.idUnidade = solicitacao.idUnidade;
            
            return this.$refs.dadosFatura.listaDepartamentos();
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.documento);
          })
          .then(() => {
            return this.carregarServicosProjeto();
          })
          .then(() => solicitacaoFaturamentoMultiservicoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.carregando = false;
          });
      },
      limparDocumento() {
        this.documento = '';
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      carregarServicosProjeto() {
        if (!this.solicitacao.idProjeto) return;
        
        return this.$refs.adicionarServicos
          .listaServicos(this.solicitacao.idProjeto);
      },
      habilitarOuDesabilitarProjeto() {
        $('#projeto').prop('disabled', this.solicitacao.itens.length > 0);
      },
      download(arquivo) {
        solicitacaoFaturamentoMultiservicoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
      'tipoDocumento': 'limparDocumento',
      'solicitacao.idProjeto': 'carregarServicosProjeto',
      'solicitacao.itens.length': 'habilitarOuDesabilitarProjeto',
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a
                  data-toggle="tab"
                  href="#tab-dados-faturamento">
                  Dados para faturamento
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#tab-dados-cobranca">
                  Dados para cobrança
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#tab-dados-fatura">
                  Dados para fatura
                </a>
              </li>
              <li :class="{'disabled': solicitacao.idProjeto === ''}">
                <a
                  data-toggle="tab"
                  @click.prevent=""
                  :data-toggle="solicitacao.idProjeto === '' ? '' : 'tab'"
                  href="#tab-adicionar-servicos">
                  Adicionar servicos
                </a>
              </li>
              <li :class="{'disabled': solicitacao.idProjeto === ''}">
                <a
                  data-toggle="tab"
                  @click.prevent=""
                  :data-toggle="solicitacao.idProjeto === '' ? '' : 'tab'"
                  href="#tab-lista-servicos">
                  Servicos
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoFaturamentoMc">
                <a
                  data-toggle="tab"
                  href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoFaturamentoMc">
                <a
                  data-toggle="tab"
                  href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-faturamento" class="tab-pane active">
                <div class="panel-body">
                  <dados-faturamento
                    ref="dadosFaturamento"
                    :solicitacao="solicitacao"
                    :carregando="carregando"
                    :edicao="!!$route.params.id">
                  </dados-faturamento>
                </div>
              </div>
              
              <div id="tab-dados-cobranca" class="tab-pane">
                <div class="panel-body">
                  <dados-cobranca
                    ref="dadosCobranca"
                    :solicitacao="solicitacao"
                    :edicao="!!$route.params.id">
                  </dados-cobranca>
                </div>
              </div>
              
              <div id="tab-dados-fatura" class="tab-pane">
                <div class="panel-body">
                  <dados-fatura
                    ref="dadosFatura"
                    :solicitacao="solicitacao"
                    :dados-bancarios="dadosBancarios"
                    :edicao="!!$route.params.id">
                  </dados-fatura>
                </div>
              </div>
              
              <div id="tab-adicionar-servicos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-servicos
                    ref="adicionarServicos"
                    :itens-solicitacao="solicitacao.itens"
                    :edicao="!!$route.params.id">
                  </adicionar-servicos>
                </div>
              </div>
              
              <div id="tab-lista-servicos" class="tab-pane">
                <div class="panel-body">
                  <lista-servicos
                    ref="listaServicos"
                    :itens-solicitacao="solicitacao.itens"
                    :edicao="!!$route.params.id">
                  </lista-servicos>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos
                    ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>
              
              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos
                    :arquivos="arquivos"
                    @download="download"
                    ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
       
      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group">
            <radio
                v-model="tipoDocumento"
                selected-value="CPF"
                type="success"
                :inline="true"
                class="no-margin-top no-margin-bottom margin-right-10">
              Pessoa Física
            </radio>
            <radio
                v-model="tipoDocumento"
                selected-value="CNPJ"
                type="success"
                :inline="true"
                class="no-margin-top no-margin-bottom">
              Pessoa Jurídica
            </radio>
          </div>
        </div>
        
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label for="documento" class="control-label">{{ tipoDocumento }} para faturamento</label>
            
            <input type="text"
               class="form-control"
               id="documento"
               v-model="documento"
               data-vv-as="documento"
               data-vv-name="documento"
               v-mascara="tipoDocumento.toLocaleLowerCase()"
               v-validate="`required|${tipoDocumento.toLocaleLowerCase()}`">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link 
                class="btn btn-default" 
                :to="{ name: 'solicitacao-faturamento-multiservicos' }" 
                v-show="!mostrarFormulario || !!$route.params.id" 
                active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
                id="avancar"
                type="button" 
                class="btn btn-primary" 
                @click="validarBeneficiario" 
                v-show="!mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar 
              <i class="fa fa-arrow-right"></i>
            </button>
            
            <button 
                type="button" 
                class="btn btn-default" 
                @click="mostrarFormulario = false, resetarComponente()" 
                v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta 
            </button>

            <button 
                id="salvar"
                type="button" 
                class="btn btn-primary" 
                @click="salvar" 
                v-show="mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar 
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-multiservicos/componentes/SolicitacaoFaturamentoMultiservicoForm.vue